<script lang="ts">
	// T18: the till's page opened in a plain browser (#371, D21; #334
	// decision 10). The till runs only inside the Bosla app, which starts the
	// till's own order store beside it, so a browser with no app has no road
	// to the API and shows this instead. It calls nothing and knows no
	// restaurant, so it names none. Built like the suspended cover (T13), from
	// the same components. Staff setting up a till download the Bosla app for
	// Windows and Android here (#392, #393), from the till files site. The
	// Windows installer is not signed yet, so Windows warns, and the line
	// under its button says how to go on.

	import BrandMark from '../components/BrandMark.svelte';
	import Button from '../components/Button.svelte';
	import Card from '../components/Card.svelte';
	import { message, type Language } from '../i18n/messages';
	import { androidDownload, windowsDownload } from '../till/download';

	interface Props {
		language: Language;
	}

	let { language }: Props = $props();

	const windows = windowsDownload();
	const android = androidDownload();
</script>

<section
	class="cover"
	aria-label={message(language, 'shellNoticeLabel')}
	data-testid="shell-notice"
>
	<div class="body">
		<BrandMark size={26} />
		<div class="head">
			<h1>{message(language, 'shellNoticeTitle')}</h1>
			<p class="tell">{message(language, 'shellNoticeTell')}</p>
		</div>
		<Card pad testId="shell-notice-owner">
			<div class="owner">
				<span class="label">{message(language, 'shellNoticeOwner')}</span>
				<Button
					testId="shell-notice-dashboard"
					label={message(language, 'shellNoticeDashboard')}
					tone="secondary"
					size="lg"
					href="/owner"
				/>
			</div>
		</Card>
		{#if windows && android}
			<Card pad testId="shell-notice-setup">
				<div class="owner">
					<span class="setup">{message(language, 'shellNoticeSetup')}</span>
					<div class="downloads">
						<Button
							testId="shell-notice-windows"
							label={message(language, 'shellNoticeWindows')}
							size="lg"
							href={windows}
						/>
						<Button
							testId="shell-notice-android"
							label={message(language, 'shellNoticeAndroid')}
							size="lg"
							href={android}
						/>
					</div>
					<span class="warn">{message(language, 'shellNoticeWindowsWarn')}</span>
				</div>
			</Card>
		{/if}
	</div>
</section>

<style>
	.cover {
		position: fixed;
		inset: 0;
		z-index: var(--z-cover);
		display: flex;
		align-items: center;
		justify-content: center;
		padding: var(--space-9);
		background: var(--surface-page);
		color: var(--text-strong);
		overflow-y: auto;
	}

	.body {
		inline-size: 100%;
		max-inline-size: 560px;
		display: flex;
		flex-direction: column;
		gap: var(--space-9);
	}

	.head {
		display: flex;
		flex-direction: column;
		gap: var(--space-3);
	}

	h1 {
		margin: 0;
		font-size: var(--text-h3);
		font-weight: 700;
		letter-spacing: var(--tracking-tight);
		line-height: var(--leading-headline);
		text-wrap: pretty;
	}

	.tell {
		margin: 0;
		font-size: var(--text-md);
		font-weight: 600;
		color: var(--text-strong);
		text-wrap: pretty;
	}

	.downloads {
		display: flex;
		flex-wrap: wrap;
		gap: var(--space-3);
	}

	.owner {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: var(--space-5);
	}

	.label {
		font-size: var(--text-base);
		color: var(--text-body);
	}

	.setup {
		font-size: var(--text-base);
		font-weight: 600;
		color: var(--text-strong);
	}

	.warn {
		font-size: var(--text-sm);
		line-height: var(--leading-snug);
		color: var(--text-body);
		text-wrap: pretty;
	}
</style>
